export const CONFIG_MERCHANT_TYPE = {
  ON_THEM: 'on_them',
  SELLER: 'seller',
  'ON US': 'on_us',
  ALIANZAMIXTO: 'alianzamixto',
  ALIANZA: 'alianza',
};
